import { Link } from "react-router-dom";
import { categories } from "@/mocks/movies";

export default function Footer() {
  return (
    <footer className="bg-[#2d2420] text-white/80">
      <div className="w-full px-4 md:px-6 py-12 md:py-16">
        <div className="max-w-7xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            <div>
              <div className="flex items-center gap-2 mb-4">
                <div className="w-9 h-9 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-film-line text-lg text-white"></i>
                </div>
                <span className="font-semibold text-lg text-white">8090电影网</span>
              </div>
              <p className="text-sm text-white/60 leading-relaxed">
                8090电影网怀旧影视专区，收录80后经典电影、90后电视剧、老电影在线观看，重温童年回忆剧，唤起青春记忆的专属片库。
              </p>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-4 text-sm">快速导航</h4>
              <ul className="space-y-2">
                <li>
                  <Link to="/" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">首页</Link>
                </li>
                {categories.slice(0, 4).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-4 text-sm">影视分类</h4>
              <ul className="space-y-2">
                {categories.slice(2).map((cat) => (
                  <li key={cat.slug}>
                    <Link
                      to={`/category/${cat.slug}`}
                      className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer"
                    >
                      {cat.name}
                    </Link>
                  </li>
                ))}
                <li>
                  <Link to="/about" className="text-sm text-white/60 hover:text-white transition-colors whitespace-nowrap cursor-pointer">关于我们</Link>
                </li>
              </ul>
            </div>

            <div>
              <h4 className="font-semibold text-white mb-4 text-sm">联系我们</h4>
              <p className="text-sm text-white/60 leading-relaxed mb-3">
                如果你有任何建议或想推荐经典影视作品，欢迎随时联系我们。
              </p>
              <Link
                to="/about"
                className="inline-block px-4 py-2 bg-primary-500 text-white text-sm rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
              >
                了解更多
              </Link>
            </div>
          </div>

          <div className="border-t border-white/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-white/40">
              &copy; {new Date().getFullYear()} 8090电影网 - 怀旧影视专区。本站内容仅供影视资料展示与怀旧交流。
            </p>
            <div className="flex items-center gap-4">
              <a href="#" className="text-xs text-white/40 hover:text-white/60 transition-colors whitespace-nowrap">隐私政策</a>
              <a href="#" className="text-xs text-white/40 hover:text-white/60 transition-colors whitespace-nowrap">使用条款</a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}